import { render, staticRenderFns } from "./PenaltyPage.vue?vue&type=template&id=a6b1f426&scoped=true&"
import script from "./PenaltyPage.vue?vue&type=script&lang=js&"
export * from "./PenaltyPage.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyPage.vue?vue&type=style&index=0&id=a6b1f426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1f426",
  null
  
)

export default component.exports